import React from "react";
import vocabwords from "./data/vocabwords.json";

function Word() {
    const wordsListLength = Object.keys(vocabwords).length
    let number = getRandomInt(wordsListLength);
    

    return (
        <div className="word-2">
            <h3>Word of the Day</h3>
            <h2>{vocabwords[number].word}</h2>
            <h4>{vocabwords[number].type}</h4>
            <h4>{vocabwords[number].definition}</h4>
        </div>
    );

    function getRandomInt(wordsListLength) {
        return Math.floor(Math.random() * Math.floor(wordsListLength));
    }
}

export default Word;